import { render } from "./FlowsPage.vue?vue&type=template&id=d118325e"
import script from "./FlowsPage.vue?vue&type=script&lang=js"
export * from "./FlowsPage.vue?vue&type=script&lang=js"

import exportComponent from "/usr/app/workspace-stack/frontend-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__